<template>
  <div class="capital_flow">
    <!--资金流水头部-->
    <div class="capital_flow_top">
      <div class="w73">交易时间:</div>
      <div>
        <el-date-picker
          v-model.trim="startTime"
          type="date"
          placeholder="开始时间"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      ~
      <div>
        <el-date-picker
          v-model.trim="endTime"
          type="date"
          placeholder="结束时间"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      <div class="w_percent15">
        <input type="text" title="业务单号" placeholder="业务单号" v-model.trim="businessNum">
      </div>
      <div>
        <el-select v-model="selectTransactionType" placeholder="交易类型">
          <el-option
            v-for="item in transactionTypeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <button class="btn_normal ml30 mr10" @click="queryData()">查询</button>
      <button class="btn_normal" @click="exportAccountBalanceHistoryDetailList()">导出数据</button>
    </div>
    <!--资金流水列表-->
    <div class="capital_flow_msg">
      <table class="table">
        <thead>
        <tr>
          <th>业务单号</th>
          <th>交易类型</th>
          <th>发生金额(元)</th>
          <th>账户结余(元)</th>
          <th>交易时间</th>
          <th>操作人</th>
          <th>备注</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td>{{item.SourceId}}</td>
          <td>{{item.Htype | capitalflowstatus}}</td>
          <td>{{item.Amount}}</td>
          <td>{{item.FinalAmount}}</td>
          <td>{{item.CreateTime | time}}</td>
          <td>{{item.CreaterName}}</td>
          <td>{{item.Remark}}</td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="7">暂时没有相关信息</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
  </div>
</template>

<script>
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'capital-flow',
    components: {LoadingDialog},
    data() {
      return {
        list: [], // 列表
        startTime: new Date(new Date() - 1000 * 60 * 60 * 24 * 7), // 开始时间
        endTime: new Date(), // 结束时间
        transactionTypeList: [], // 交易类型列表
        selectTransactionType: null, // 选择的交易类型
        businessNum: null, // 业务单号
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载框类型
        currentPage: 1, // 当前页数
        pageSize: 0, // 当前显示几条数据
        total: 10 // 总条数
      }
    },
    methods: {
      // 获取当前时间 + 7天前时间
      getTime() {
        const nowDate = new Date();
        this.startTime = new Date(nowDate - 1000 * 60 * 60 * 24 * 7);
        this.endTime = new Date();
      },

      // 加载分销商资金流水交易类型下拉数据
      getWaterStatus() {
        this.$axios.get(this.Global.getWaterStatus).then((res) => {
          if (!res.data.errorMsg.length) {
            this.transactionTypeList = res.data.resData;
            this.transactionTypeList.splice(0, 0, {id: null, text: '交易类型'});
            this.selectTransactionType = null;
          } else {
            // alert(res.data.errorMsg);
            this.transactionTypeList = [];
            this.selectTransactionType = res.data.errorMsg;
          }
        });
      },

      // 查询数据
      queryData() {
        if (!this.startTime && !this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择交易时间';
          return;
        } else if (!this.startTime && this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择开始时间';
          return;
        } else if (this.startTime && !this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择结束时间';
          return;
        } else if (this.startTime > this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '开始时间不能大于结束时间';
          return;
        }
        this.currentPage = 1;
        this.getAccountBalanceHistoryDetailList();
      },

      // 获取资金流水分页数据
      getAccountBalanceHistoryDetailList() {
        this.isLoading = true;
        const params = {
          UseStatus: this.selectTransactionType,
          IdOrName: this.businessNum,
          BeginCreateTime: this.Global.timeFormatStart(this.startTime),
          EndCreateTime: this.Global.timeFormatEnd(this.endTime),
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.getAccountBalanceHistoryDetailList, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              } else {
                self.list = [];
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 导出资金流水
      exportAccountBalanceHistoryDetailList() {
        if (!this.startTime && this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择开始时间';
          return;
        } else if (this.startTime && !this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择结束时间';
          return;
        } else if (this.startTime > this.endTime) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '开始时间不能大于结束时间';
          return;
        }
        const params = {
          UseStatus: this.selectTransactionType,
          IdOrName: this.businessNum,
          BeginCreateTime: this.startTime,
          EndCreateTime: this.endTime
        };
        this.$axios.post(this.Global.exportAccountBalanceHistoryDetailList, params).then((res) => {
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.getAccountBalanceHistoryDetailList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getAccountBalanceHistoryDetailList();
      }
    },
    created() {
      this.getTime();
      this.getWaterStatus();
      this.getAccountBalanceHistoryDetailList();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.getTime();
        this.selectTransactionType = null;
        this.businessNum = null;
        // this.startTime = null;
        // this.endTime = null;
        this.currentPage = 1;
        this.pageSize = 10;
        this.getAccountBalanceHistoryDetailList();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";
  @import "../../../assets/css/base-color";

  .capital_flow {
    .capital_flow_top {
      margin-top: 10px;
      margin-bottom: 10px;
      padding: 0 15px;

      & > div {
        display: inline-block;
        width: 13%;

        &.w_percent15 {
          width: 15%;
        }

        &.w73 {
          width: 73px;
        }
      }
    }

    .capital_flow_msg {
      padding: 10px;
      font-size: 12px;

      table {
        td {
          min-width: 60px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/money-management/capital-flow.vue